import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import './AlertBanner.css'

const AlertBanner = () => {

    const [alerts, setAlerts] = useState([])
    // Set of alert IDs the customer has dismissed this session
    const [dismissed, setDismissed] = useState(() => {
        try {
            return new Set(JSON.parse(sessionStorage.getItem('dismissed-alerts') || '[]'))
        } catch { return new Set() }
    })

    const stackRef = useRef(null)

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/site-settings`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    // Only show active alerts
                    setAlerts((data.settings.alerts || []).filter(a => a.active))
                }
            })
            .catch(console.error)
    }, [])

    // Measure banner stack height and write it to a CSS variable
    // Navbar reads --alert-height to know where to sit
    useLayoutEffect(() => {
        const update = () => {
            const h = stackRef.current ? stackRef.current.offsetHeight : 0
            document.documentElement.style.setProperty('--alert-height', `${h}px`)
        }
        update()
        window.addEventListener('resize', update)
        return () => {
            window.removeEventListener('resize', update)
            document.documentElement.style.setProperty('--alert-height', '0px')
        }
    }, [alerts, dismissed])

    const dismiss = (alertId) => {
        const next = new Set(dismissed)
        next.add(alertId)
        setDismissed(next)
        sessionStorage.setItem('dismissed-alerts', JSON.stringify([...next]))
    }

    // Alerts to actually render — active and not dismissed
    const visible = alerts.filter(a => !dismissed.has(a.id))
    if (visible.length === 0) return null

    return (
        <div className="alert-banner-stack" ref={stackRef}>
            {visible.map(alert => (
                <div key={alert.id} className={`alert-banner alert-banner--${alert.type}`}>
                    <span className="alert-banner-msg">{alert.message}</span>
                    {alert.dismissible && (
                        <button
                            className="alert-banner-close"
                            onClick={() => dismiss(alert.id)}
                            aria-label="Dismiss"
                        >✕</button>
                    )}
                </div>
            ))}
        </div>
    )
}

export default AlertBanner